export var EAuthStrategy;
(function (EAuthStrategy) {
    EAuthStrategy["OAUTH_MICROSOFT"] = "OAUTH_MICROSOFT";
    EAuthStrategy["OAUTH_GOOGLE"] = "OAUTH_GOOGLE";
    EAuthStrategy["OAUTH_FACEBOOK"] = "OAUTH_FACEBOOK";
    EAuthStrategy["OAUTH_TWITTER"] = "OAUTH_TWITTER";
    EAuthStrategy["OAUTH_OPENID_OHIO"] = "OAUTH_OPENID_OHIO";
})(EAuthStrategy || (EAuthStrategy = {}));
